/* eslint-disable import/prefer-default-export */
import icon from '../assets/scilogex-favicon.ico';

export const scilogexConfig = {
  title: 'Scilogex',
  catalog: 'partner',
  partner: 'scilogex',
  origin: 'https://www.scilogex.com/',
  host: 'https://chairs.scilogex.com/',
  logo: 'https://ecomseating.s3.amazonaws.com/images/other/scilogex-logo.png',
  logoURL: 'https://ecomseating.s3.amazonaws.com/images/other/scilogex-logo.png',
  buildAChair: 'scilogex',
  businessInfo: 'SCILOGEX, LLC, 1275 Cromwell Avenue, C-6, Rocky Hill, CT06067',
  headerTheme: '#FFFFFF',
  secondaryTheme: '#FF8739',
  footerTheme: '#212529',
  headerTextColor: '#727272',
  footerTextColor: '#FFFFFF',
  buttonTextColor: '#FFFFFF',
  extraAttributes: {
    trackId: 'G-J8R06K4DSP',
    icon,
  },
};
